import Button from "../../Common/Components/ButtonComponent/Button";

const NumberScrollSegmentCard = ({
  index,
  buttonData,
  handleInputChange,
  errors,
  removeButton,
  isEditable,
  isLoading,
  segmentId,
  pageId,
}) => {
  return (
    <div className="bg-white border border-black-600 rounded-[5px] px-4 py-4">
      <label className="inline-block mb-2 text-base font-medium">
        Number Value
      </label>
      <input
        type="text"
        disabled={!isEditable}
        value={buttonData?.number_value}
        onChange={(e) =>
          handleInputChange(index, "number_value", e.target.value)
        }
        className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
        placeholder="Enter Number Value"
      />
      {errors.buttons[index]?.number_value && (
        <p className="text-sm text-red-500">
          {errors.buttons[index].number_value}
        </p>
      )}

      <label className="inline-block mb-2 text-base font-medium">Text</label>
      <input
        type="text"
        disabled={!isEditable}
        value={buttonData?.text}
        onChange={(e) => handleInputChange(index, "text", e.target.value)}
        className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
        placeholder="Enter Text"
      />
      {errors.buttons[index]?.text && (
        <p className="text-sm text-red-500">{errors.buttons[index].text}</p>
      )}

      <div className="flex justify-end mt-2">
        <Button
          btnText="Remove"
          onClick={() => removeButton(index)}
          disabled={!isEditable}
          isLoading={isLoading}
          pageId={pageId}
          id={segmentId}
          className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
        />
      </div>
    </div>
  );
};

export default NumberScrollSegmentCard;
